import { render } from "./CreateLegacyFlow.vue?vue&type=template&id=2677450b"
import script from "./CreateLegacyFlow.vue?vue&type=script&lang=js"
export * from "./CreateLegacyFlow.vue?vue&type=script&lang=js"
script.render = render

export default script